import { DocumentLibraryService } from "./service"

export function setupDoclib(module: ng.IModule) {

    module

        .service("OmniaDocumentLibraryService", DocumentLibraryService)

}
